<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs7>
        <h2 class='amaze-title'>Amaze</h2>
        <p>Oops. We have a slight problem. The token needed to reset your password got lost in the shuffle!</p>

        <p>Let's try that again.</p>
        <v-btn color="primary" to="forgot-password">
            Reset Password
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return { };
  }
};
</script>
